module.exports = __webpack_public_path__ + "assets/img/patient-tracking.37f5aa64.svg";